import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';
import { Modal } from 'react-bootstrap';

import { Button } from 'components/shared/button';

import './toggleModal.scss';

interface ToggleModalProps {
  show: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  modalTitle: string;
  modalText: string;
}

export const ToggleModal = ({
  show,
  handleClose,
  handleConfirm,
  modalTitle,
  modalText
}: ToggleModalProps): JSX.Element => {
  return (
    <Modal show={show}>
      <div className="modal-header">
        <h2>{modalTitle}</h2>
        <a onClick={handleClose} data-testid="close-button" id="close-button">
          <SvgIcon type={'cross' as HpSvgIconTypes} size="small" />
        </a>
      </div>
      <p className="av-text-large">{modalText}</p>
      <div className="modal-actions">
        <Button handleClick={handleClose} text="NO" id="no-button" />
        <Button handleClick={handleConfirm} text="YES" id="yes-button" variant="reversed" />
      </div>
    </Modal>
  );
};
